import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const DefaultPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <TextField label="Рейтинг" size="small" value={asNumber(value.rating)} onChange={(e) => setNumber(value, 'rating', e.target.value, onChange)} />
    <TextField label="Категория" size="small" value={asString(value.category)} onChange={(e) => setString(value, 'category', e.target.value, onChange)} />
    <TextField
      label="Примечание"
      size="small"
      value={asString(value.note)}
      onChange={(e) => setString(value, 'note', e.target.value, onChange)}
      sx={{ gridColumn: { sm: '1 / -1' } }}
    />
    <Typography variant="caption" color="text.secondary" sx={{ gridColumn: { sm: '1 / -1' } }}>
      Для этого вида спорта используется универсальный профиль.
    </Typography>
  </Box>
);
